export const data = []

export const FILED_MAP = {
  applicantName: 'real.realName',
  contactName: 'real.realName',
  legalPerson: 'real.realName',
  applicantSex: 'real.sex',
  contactSex: 'real.sex',
  applicantIdCard: 'real.certNo',
  contactIdCard: 'real.certNo',
  legalPersonIdCard: 'real.certNo',
  cardType: 'real.documentType',
  contactCardType: 'real.documentType',
  legalPersonCardType: 'real.documentType',
  applicantAddress: 'naturalBase.contactAddress',
  // applicantAddress: 'real.address',
  applicantEmail: 'naturalBase.employeeMail',
  applicantPhone: 'naturalBase.employeeMobile',
  contactPhone: 'naturalBase.employeeMobile',
}

export const FR_FILED_MAP = {
  orgName: 'legalBase.deptName',
  orgAddress: 'legalBase.registerAddr',
  // orgCardType: 'real.realName',
  orgIdCard: 'legalBase.deptCode',
  legalPerson: 'legalBase.deptPerson',
  legalPersonCardType: 'legalBase.deptPersonCodeType',
  legalPersonIdCard: 'legalBase.deptPersonCode',

  applicantName: 'legalBase.currentPerson_Info.realName',
  cardType: 'legalBase.deptPersonCodeType',
  applicantIdCard: 'legalBase.currentPerson_Info.idNumber',
  applicantAddress: 'legalBase.currentPerson_Info.contactAddress',
  applicantPhone: 'legalBase.currentPerson_Info.employeeMobile',
  // applicantPostalCode: 'real.realName',
  applicantEmail: 'legalBase.currentPerson_Info.employeeMail',
  // remark: 'real.realName',

  contactName: 'legalBase.deptPerson',
  // contactSex: 'real.realName',
  contactCardType: 'legalBase.deptPersonCodeType',
  contactIdCard: 'legalBase.deptPersonCode',
  contactPhone: 'legalBase.employeeMobile',
}
